import { AttachmentType } from './enums'

export interface AttachmentCreateResponse {
    recognitionResult?: AttachmentCreateResultData
    id: string,
    type: AttachmentType,
    ownerId: string,
    overwrite: boolean,
    url: string
}

export interface AttachmentCreateResultData {
    moderationLabels?: string[]
    celebrityFaces?: string[]
}

export class AttachmentCreateResult implements AttachmentCreateResultData {
    moderationLabels?: string[]
    celebrityFaces?: string[]

    constructor(data?: AttachmentCreateResultData) {
        if (data) {
            this.moderationLabels = data.moderationLabels
            this.celebrityFaces = data.celebrityFaces
        }
    }

    get isImageValid(): boolean {
        return (
            (!this.moderationLabels || this.moderationLabels.length === 0) &&
            (!this.celebrityFaces || this.celebrityFaces.length === 0)
        )
    }
}



// WEBPACK FOOTER //
// ./src/types/AttachmentCreateResult.ts